import React, { useEffect, useState } from 'react';
import { Text, Colors, PrimaryButton } from 'library';
import { Grid, Radio } from '@material-ui/core';
import Label from 'reusableComponents/checkboxLabel';
import { track } from 'shared';
import UserAttributesApi from 'shared/UserAttributesApi';
import LanguageIcon from '@material-ui/icons/Language';
import PeopleIcon from '@material-ui/icons/People';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';

export default function CommunityRepresentative({ modal = false }: { modal?: boolean }) {
    const points = [
        { icon: <LanguageIcon style={{ color: Colors.mediumTurq }} />, text: 'Post on social media' },
        { icon: <PeopleIcon style={{ color: Colors.mediumTurq }} />, text: 'Share within your community' },
        { icon: <RecordVoiceOverIcon style={{ color: Colors.mediumTurq }} />, text: 'Tell your friends' },
        { icon: <ContactMailIcon style={{ color: Colors.mediumTurq }} />, text: 'Send provider profiles' },
    ];

    const [answer, setAnswer] = useState<boolean>(true);
    const [submitted, setSubmitted] = useState<boolean>(false);

    function onSubmit() {
        if (answer) {
            UserAttributesApi.create('Community Representative Interested');
            track('Family interested in becoming a community representative', { modal: modal });
        } else {
            UserAttributesApi.create('Community Representative Not Interested');
            track('Family not interested in becoming a community representative', { modal: modal });
        }
        setSubmitted(true);
    }
    return (
        <Grid container style={{ padding: 20 }}>
            <Grid item xs={12}>
                <Text variant="h2" bold color={Colors.turquoise}>
                    Become a community representative!
                </Text>
            </Grid>
            <Grid item xs={12} style={{ padding: '30px 0px' }}>
                <Grid
                    container
                    justify="space-around"
                    style={{ padding: '30px 30px', borderWidth: 1, borderStyle: 'solid', borderRadius: 30 }}
                >
                    {points.map((point, index) => (
                        <Grid item style={{ width: 100 }}>
                            <Grid container direction="column" alignItems="center" style={{ textAlign: 'center' }}>
                                {point.icon}
                                <Text variant="body1" bold>
                                    {point.text}
                                </Text>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Text variant="body2" color={Colors.darkGrey}>
                    Help Tandem grow by representing Tandem in your community! Representatives have access to special
                    resources to share Tandem, earn money and other discounts for their efforts.
                </Text>
            </Grid>
            <Grid container item alignItems="center" justify="space-between" style={{ marginTop: 20 }}>
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <Label
                                control={
                                    <Radio
                                        checked={answer}
                                        color="primary"
                                        onClick={() => {
                                            track('Family changed community representative answer', {
                                                newAnswer: answer,
                                            });
                                            setAnswer(true);
                                        }}
                                        disableFocusRipple
                                    />
                                }
                                label={<Text variant="body1">Yes</Text>}
                            />
                        </Grid>
                        <Grid item>
                            <Label
                                control={
                                    <Radio
                                        checked={!answer}
                                        color="primary"
                                        onClick={() => {
                                            track('Family changed community representative answer', {
                                                newAnswer: answer,
                                            });
                                            setAnswer(false);
                                        }}
                                        disableFocusRipple
                                    />
                                }
                                label={<Text variant="body1">No</Text>}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <PrimaryButton onClick={onSubmit} disabled={submitted}>
                        Submit
                    </PrimaryButton>
                </Grid>
            </Grid>
            <Grid container>
                {submitted ? (
                    <Text variant="deprecatedCaption" textStyle={{ marginLeft: 5 }}>
                        Thanks for letting us know!
                    </Text>
                ) : null}
            </Grid>
        </Grid>
    );
}
